import AtorTable from '@/components/AtorTable.vue';
import BacklogSprint from '@/components/BacklogSprint.vue';
import BurndownChart from '@/components/BurndownChart.vue';
import CasoDeUso from '@/components/CasoDeUso.vue';
import Charter from '@/components/Charter.vue';
import CharterList from '@/components/CharterList.vue';
import ClassificacaoItens from '@/components/ClassItens.vue';
import ContribuicaoCharters from '@/components/ContribuicaoCharters.vue';
import ContribuicaoGithub from '@/components/ContribuicaoGithub.vue';
import Contribution from '@/components/ContributionList';
import CreateValidationPeriod from '@/components/CreateValidationPeriod.vue';
import Dashboard from '@/components/DashboardList.vue';
import DetalhesBug from '@/components/DetalhesBug.vue';
import UseCaseModal from '@/components/dialogs/UseCaseModal.vue';
import EvolucaoDev from '@/components/EvolucaoDesenvolvedor.vue';
import EvolucaoScrum from '@/components/EvolucaoScrum.vue';
import Formulario from '@/components/FormsList.vue';
import FormularioExecucaoTestador from '@/components/FormularioExecucaoTestador.vue';
import FormularioValidacao from '@/components/FormularioValidacao.vue';
import GeralRating from '@/components/GeralRating.vue';
import IndividualSM from '@/components/IndividualSM.vue';
import ItensAvaliacao from '@/components/ItensAvaliacao.vue';
import ListaBugs from '@/components/ListaBugs.vue';
import ListaResultadosRoteiros from '@/components/ListaResultadosRoteiros.vue';
import ListaRoteiros from '@/components/ListaRoteiros.vue';
import ListTestUsers from '@/components/ListTestUsers.vue';
import MyRating from '@/components/MyRating.vue';
import NovoRoteiro from '@/components/NovoRoteiro.vue';
import ProdutoBacklog from '@/components/ProdutoBacklog.vue';
import ProjectDashboard from '@/components/ProjectDashboard.vue';
import Projects from '@/components/ProjectsList.vue';
import ProjectsCoord from '@/components/ProjectsListCoord.vue';
import ProjectsDev from '@/components/ProjectsListDev.vue';
import ProjectsScrum from '@/components/ProjectsListScrum.vue';
import ProjectValidationDashboard from '@/components/ProjectValidationDashboard.vue';
import RatingCoord from '@/components/RatingsListCoord.vue';
import RatingDev from '@/components/RatingsListDev.vue';
import RatingScrum from '@/components/RatingsListScrum.vue';
import Ratings from '@/components/RatingsOptions.vue';
import RatingsSM from '@/components/RatingsSM.vue';
import RequisitoTela from '@/components/RequisitoTela.vue';
import ResultadosValidacaoFuncionalidade from '@/components/ResultadosValidacaoFuncionalidade.vue';
import Roteiro from '@/components/Roteiro.vue';
import RoteiroTestador from '@/components/RoteiroTestador.vue';
import Sprint from '@/components/SprintList.vue';
import StackHolderETable from '@/components/StakeHolderETable.vue';
import StatusBugBacklog from '@/components/StatusBugBacklog.vue';
import StatusTarefaBacklog from '@/components/StatusTarefaBacklog.vue';
import TabelaBugs from '@/components/TabelaBugs.vue';
import TabelaFormValidacao from '@/components/TabelaFormValidacao.vue';
import TabelaReqPorProjeto from '@/components/TabelaReqPorProjeto.vue';
import TabelaRequisitos from '@/components/TabelaRequisitos.vue';
import TabelaValidacoes from '@/components/TabelaValidacoes.vue';
import TaskInfo from '@/components/TaskInfo.vue';
import BacklogTarefas from '@/components/TasksList.vue';
import Team from '@/components/TeamList.vue';
import TestesEquipe from '@/components/TestesEquipe.vue';
import TestesIndependentes from '@/components/TestesIndependentes.vue';
import UseCasesTable from '@/components/UseCasesTable.vue';
import Users from '@/components/UsersList.vue';
import ValidationDetails from '@/components/ValidationDetails.vue';
import ValidationScope from '@/components/ValidationScope.vue';
import VelocityChart from '@/components/VelocityChart.vue';
import WorkspaceConvidado from '@/components/WorkspaceConvidado.vue';
import TelaAtualizarSenha from '@/views/TelaAtualizarSenha';
// import TelaProjeto from '@/views/TelaProjeto';
import TelaHome from '@/views/TelaHome';
import TelaLogin from '@/views/TelaLogin';
import TelaNotFound from '@/views/TelaNotFound';
import TelaRecuperacao from '@/views/TelaRecuperacao';
import TelaValidacao from '@/views/TelaValidacao';
import TelaVisualizacaoConvite from '@/views/TelaVisualizacaoConvite';
/* eslint-disable */
/**
 * Array de objetos que representam as rotas da aplicação
 * @type {Array}
 * @property {string} path - O caminho da rota
 * @property {Object} component - O componente a ser renderizado na rota
 * @property {Object} meta - Metadados da rota
 * @property {boolean} meta.requiresAuth - Indica se a rota requer autenticação
 * @property {string} redirect - O caminho para redirecionar quando a rota raiz é acessada
 * @property {Array} children - Um array de rotas filhas
 * @property {string} children[].path - O caminho da rota filha
 * @property {Object} children[].component - O componente a ser renderizado na rota filha
 * @property {Object} children[].meta - Metadados da rota filha
 * @property {boolean} children[].meta.requiresAuth - Indica se a rota filha requer autenticação
 * @property {string} name - O nome da rota
 */
const routes = [
  {
    path: '/login',
    component: TelaLogin,
  },
  {
    path: '/',
    component: TelaHome,
    meta: { requiresAuth: true },
    redirect: () => {
      const funcao = localStorage.getItem('funcao');
      if (funcao === 'Scrum Master') return '/projectsScrum';
      if (funcao === 'Coordenador') return '/projectsCoord';
      if (funcao === 'Desenvolvedor') return '/projectsDev';
      if (funcao === 'Testador') return '/projects';
      if (funcao === 'Usuario Testador') return '/workspace-convidado';
      return '/projects';
    },
    children: [
      {
        path: '/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true },
      },
      {
        path: '/sprint/:id',
        name: 'sprint',
        component: Sprint,
        meta: { requiresAuth: true, role: ['Desenvolvedor', 'Scrum Master'] },
      },
      {
        path: '/rating/form/:id_proj/:id',
        name: 'rating360',
        component: GeralRating,
        meta: {
          requiresAuth: true,
          role: ['Desenvolvedor'],
        },
      },
      {
        path: '/allratings/:id_proj/:id/:titulo',
        name: 'allRatings360',
        component: RatingsSM,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/allratingsIndividual/:id_proj/:nomeAvaliacao/:id/:nomeProjeto',
        name: 'allRatingsIndividual',
        component: IndividualSM,
        meta: {
          requiresAuth: true,
        },
        props: true,
      },
      {
        path: '/myrating/form/:id_proj/:id',
        name: 'myRating360',
        component: MyRating,
        meta: {
          requiresAuth: true,
          role: ['Desenvolvedor'],
        },
      },
      {
        path: '/rating/:id/:nome',
        name: 'ratingCoord',
        component: RatingCoord,
        props: true,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/ratingDev/:id/:nome',
        name: 'ratingDev',
        component: RatingDev,
        props: true,
        meta: { requiresAuth: true, role: ['Desenvolvedor'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/ratingScrum/:id/:nome',
        name: 'ratingScrum',
        component: RatingScrum,
        props: true,
        meta: { requiresAuth: true, role: ['Scrum Master'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Scrum Master') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/ratings',
        component: Ratings,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/classItems',
        component: ClassificacaoItens,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/items',
        component: ItensAvaliacao,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/forms',
        component: Formulario,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/projects',
        component: Projects,
        meta: { requiresAuth: true },
      },
      {
        path: '/projectsCoord',
        component: ProjectsCoord,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/projectsDev',
        component: ProjectsDev,
        meta: { requiresAuth: true, role: ['Desenvolvedor'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/projectsScrum',
        component: ProjectsScrum,
        meta: { requiresAuth: true, role: ['Scrum Master'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Scrum Master') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/sprints/backlog/:id',
        name: 'sprints/backlog',
        component: BacklogSprint,
        meta: { requiresAuth: true },
      },
      {
        path: '/sprints/backlog/:id/tarefa/:idTarefa',
        name: 'sprints/backlog/tarefa',
        component: TaskInfo,
        meta: { requiresAuth: true },
      },
      {
        path: '/tasks/backlog/:id',
        name: 'tasks/backlog',
        component: BacklogTarefas,
        meta: { requiresAuth: true },
      },
      {
        path: '/team',
        component: Team,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/contribution/:id',
        name: 'contribution',
        component: Contribution,
        meta: { requiresAuth: true },
      },
      {
        path: '/users',
        component: Users,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/evolucao/:id',
        name: 'evolucao',
        component: EvolucaoDev,
        meta: { requiresAuth: true, role: ['Desenvolvedor'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/evolucao/:id/membros',
        name: 'evolucao/membros',
        component: EvolucaoScrum,
        meta: { requiresAuth: true, role: ['Scrum Master'] },
        beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Scrum Master') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/contribuicao-github/:id/:nome',
        name: 'contribuicao-github',
        component: ContribuicaoGithub,
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: '/contribuicao-charters/:id/:nome',
        name: 'contribuicao-charters',
        component: ContribuicaoCharters,
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: '/barras-bug-status/:id',
        name: 'barras-bug-status',
        component: StatusBugBacklog,
        meta: { requiresAuth: true },
      },
      {
        path: '/barras-backlog-produto/:id',
        name: 'barras-backlog-produto',
        component: ProdutoBacklog,
        meta: { requiresAuth: true },
      },
      {
        path: '/barras-status-tarefa/:id',
        name: 'barras-status-tarefa',
        component: StatusTarefaBacklog,
        meta: { requiresAuth: true },
      },
      {
        path: '/velocity-chart/:id',
        name: 'velocity-chart',
        component: VelocityChart,
        meta: { requiresAuth: true },
      },
      {
        path: '/burndown-chart/:id/:idSprint',
        name: 'burndown-chart',
        component: BurndownChart,
        meta: { requiresAuth: true },
      },

      { path: '/projects/:idProjeto', component: ProjectDashboard },
      { path: '/projects/:idProjeto/Ator/', component: AtorTable },
      {
        path: '/projects/:idProjeto/StackHolderE/',
        component: StackHolderETable,
      },
      { path: '/projects/:idProjeto/CasoUso/', component: UseCasesTable },
      { path: '/projects/:idProjeto/CasoUso/modal', component: UseCaseModal },
      { path: '/projects/:idProjeto/CasoUso/:id', component: CasoDeUso },
      {
        path: '/projects/:idProjeto/CasoUso/:id/Requisitos/',
        component: TabelaRequisitos,
      },
      {
        path: '/projects/:idProjeto/Requisitos/',
        component: TabelaReqPorProjeto,
      },
      {
        path: '/projects/:idProjeto/validation-scope/',
        component: ValidationScope,
        meta: {
          requiresAuth: true,
          role: ['Desenvolvedor', 'Coordenador'],
        },
         beforeEnter: (to, from, next) => {
          // Aqui você deve verificar o tipo do usuário
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor' || userType === 'Coordenador') {
            next(); // permite o acesso à rota
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.'
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            store.commit('resetState');
            next('/login'); // redireciona para login
          }
        },
      },
      {
        path: '/projects/:idProjeto/Bugs/',
        component: ListaBugs,
      },
      {
        path: '/projects/:idProjeto/resultados-roteiros/',
        component: ListaResultadosRoteiros,
        meta: {
          requiresAuth: true,
          role: ['Desenvolvedor', 'Testador', 'Scrum Master', 'Coordenador', 'Product Owner'],
        },
      },
      {
        path: '/projects/:idProjeto/resultados-funcionalidade/:idFormularioEscopo',
        component: ResultadosValidacaoFuncionalidade,
        meta: {
          requiresAuth: true,
          role: ['Desenvolvedor', 'Testador', 'Scrum Master', 'Coordenador', 'Product Owner'],
        },
      },
      { path: '/projects/:idProjeto/CasoUso/:idCasoUso/Requisitos/:id', component: RequisitoTela },
      { path: '/projects/:idProjeto/Requisitos/:id', component: RequisitoTela },
      { path: '/projects/:idProjeto/Bugs/:id', component: DetalhesBug },
      { path: '/projects/:idProjeto/CasoUso/:id/Bugs/', component: TabelaBugs },
      { path: '/projects/:idProjeto/Charters/:id', component: Charter },
      { path: '/projects/:idProjeto/Charters/', component: CharterList },
      {
        path: '/projects/:idProjeto/testesIndependentes/',
        component: TestesIndependentes,
      },
      { path: '/projects/:idProjeto/testesEquipe/', component: TestesEquipe },

      {
        path: '/validations',
        component: TabelaValidacoes,
        meta: { requiresAuth: true, role: ['Coordenador', 'Desenvolvedor', 'Scrum Master'] },
      },
      {
        path: '/create-validation-period',
        component: CreateValidationPeriod,
        meta: { requiresAuth: true, role: ['Coordenador'] },
      },
      {
        path: '/create-validation-period/:id',
        component: CreateValidationPeriod,
        meta: { requiresAuth: true, role: ['Coordenador'] },
      },
      {
        path: '/gestao-formularios-validacao',
        component: TabelaFormValidacao,
        meta: { requiresAuth: true, role: ['Coordenador'] },
      },
      {
        path: '/formulario-validacao/novo',
        component: FormularioValidacao,
        meta: { requiresAuth: true, role: ['Coordenador'] },
      },
      {
        path: '/formulario-validacao/:id',
        component: FormularioValidacao,
        meta: { requiresAuth: true, role: ['Coordenador'] },
      },
      {
        path: '/validation-details/:id',
        component: ValidationDetails,
        meta: { requiresAuth: true, role: ['Coordenador'] },
        beforeEnter: (to, from, next) => {
          const userType = localStorage.getItem('funcao');
          if (userType === 'Coordenador') {
            next();
          } else {
            alert('Você não tem permissão para visualizar essa página!');
            next('/validations');
          }
        },
      },

      {
        path: '/project-validation/:idProjeto',
        component: ProjectValidationDashboard,
        meta: {
          requiresAuth: true,
          role: ['Coordenador', 'Desenvolvedor', 'Scrum Master'],
        },
        beforeEnter: (to, from, next) => {
          const userType = localStorage.getItem('funcao');
          if (['Coordenador', 'Desenvolvedor', 'Scrum Master'].includes(userType)) {
            next();
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            if (typeof store !== 'undefined') store.commit('resetState');
            next('/login');
          }
        },
      },
      {
        path: '/projects/:idProjeto/roteiros/',
        component: ListaRoteiros,
        meta: {
          requiresAuth: true,
          role: ['Coordenador', 'Desenvolvedor', 'Scrum Master', 'Testador'],
        },
        beforeEnter: (to, from, next) => {
          const hasAccess = localStorage.getItem('scrum') === 'sim' ||
                            localStorage.getItem('dev') === 'sim' ||
                            localStorage.getItem('coord') === 'sim' ||
                            localStorage.getItem('testador') === 'sim';
          if (hasAccess) {
            next();
          } else {
            alert('Você não tem permissão para visualizar essa página!');
            next('/projects');
          }
        },
      },
      {
        path: '/projects/:idProjeto/roteiros/create',
        component: NovoRoteiro,
        meta: { requiresAuth: true, role: ['Desenvolvedor'] },
        beforeEnter: (to, from, next) => {
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor') {
            next();
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            if (typeof store !== 'undefined') store.commit('resetState');
            next('/login');
          }
        },
      },
      {
        path: '/projects/:idProjeto/roteiros/:idRoteiro/edit',
        component: NovoRoteiro,
        meta: { requiresAuth: true, role: ['Desenvolvedor'] },
        beforeEnter: (to, from, next) => {
          const userType = localStorage.getItem('funcao');
          if (userType === 'Desenvolvedor') {
            next();
          } else {
            alert(
              'Você não tem permissão para visualizar essa página porque não está na visão que permite você visualizá-la! Por favor, recarregue a página, faça login novamente e, então, selecione a visão desejada para que você possa ver a página.',
            );
            localStorage.removeItem('token');
            localStorage.removeItem('dev');
            localStorage.removeItem('coord');
            localStorage.removeItem('scrum');
            if (typeof store !== 'undefined') store.commit('resetState');
            next('/login');
          }
        },
      },
      {
        path: '/projects/:idProjeto/roteiros/:idRoteiro/revisar',
        component: Roteiro,
        meta: { requiresAuth: true, role: ['Scrum Master', 'Testador', 'Desenvolvedor', 'Coordenador'] },
        beforeEnter: (to, from, next) => {
          const hasAccess = localStorage.getItem('scrum') === 'sim' ||
                            localStorage.getItem('dev') === 'sim' ||
                            localStorage.getItem('coord') === 'sim' ||
                            localStorage.getItem('testador') === 'sim';
          if (hasAccess) {
            next();
          } else {
            alert('Você não tem permissão para visualizar essa página!');
            next('/projects');
          }
        },
      },
      {
        path: '/projects/:idProjeto/test-users',
        name: 'test-users',
        component: ListTestUsers,
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: '/workspace-convidado',
        name: 'workspace-convidado',
        component: WorkspaceConvidado,
        meta: { requiresAuth: true },
      },
      {
        path: '/projects/:idProjeto/roteiros/:idRoteiro/executar',
        name: 'roteiro-executar',
        component: RoteiroTestador,
        meta: { requiresAuth: true },
      },
      {
        path: '/projects/:idProjeto/roteiros/:idRoteiro/executar/:idEscopoTeste/formulario',
        name: 'roteiro-formulario',
        component: FormularioExecucaoTestador,
        meta: { requiresAuth: true },
      },
    ],
  },


  {
    path: '/validacao',
    component: TelaValidacao,
  },

  {
    path: '/recuperacao',
    component: TelaRecuperacao,
  },

  {
    path: '/atualizacao',
    component: TelaAtualizarSenha,
  },
  {
    path: '/convite/:nome/:nomeProjeto',
    name: 'convite',
    component: TelaVisualizacaoConvite,
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: TelaNotFound,
  },


];

export default routes;
